import {remCalc} from '../../_utils'

/**
 * Sticky agent banner shown above the sovra-header while a Sales Assistant is
 * logged in. It stays pinned at the very top during scrolling.
 */
export default {
    parts: [
        'container',
        'dashboardButton',
        'group',
        'customerRow',
        'cluster',
        'roleLabel',
        'trigger',
        'triggerName',
        'chevron',
        'menuList',
        'menuItem',
    ],
    baseStyle: () => ({
        container: {
            position: 'sticky',
            top: 0,
            zIndex: 1300,
            w: '100%',
            backgroundColor: 'background.light-blue',
            color: 'text.default',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            columnGap: {base: remCalc(8), lg: remCalc(16)},
            rowGap: {base: remCalc(4), md: 0},
            paddingInline: {base: remCalc(16), md: remCalc(24)},
            paddingBlock: {base: remCalc(8), lg: remCalc(10)},
        },
        dashboardButton: {
            flexShrink: 0,
            fontWeight: 'medium',
            textDecoration: 'underline',
            textStyle: {base: 'body-xsmall', lg: 'body-small'},
            color: 'text.default',
            whiteSpace: 'nowrap',
        },
        group: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            minW: 0,
        },
        customerRow: {
            display: 'flex',
            flex: {base: '0 0 100%', md: 'none'},
            justifyContent: {base: 'center', md: 'flex-start'},
            marginLeft: {base: 0, md: remCalc(12), lg: remCalc(32)},
        },
        cluster: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(6),
            minW: 0,
        },
        roleLabel: {
            fontWeight: 'medium',
            textStyle: {base: 'body-xsmall', lg: 'body-small'},
            whiteSpace: 'nowrap',
            flexShrink: 0,
        },
        trigger: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: remCalc(4),
            cursor: 'pointer',
            minW: 0,
            background: 'transparent',
            fontWeight: 'normal',
            textStyle: {base: 'body-xsmall', lg: 'body-small'},
            color: 'text.default',
            _hover: {textDecoration: 'underline'},
            _focusVisible: {boxShadow: 'outline', outline: 'none'},
        },
        triggerName: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxW: {base: remCalc(140), md: remCalc(260)},
        },
        chevron: {
            boxSize: 'iconsSize.medium',
            flexShrink: 0,
        },
        menuList: {
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: remCalc(8),
            zIndex: 10,
            w: remCalc(240),
            maxW: 'calc(100vw - 32px)',
            backgroundColor: 'white',
            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
            display: 'flex',
            flexDirection: 'column',
            px: remCalc(16),
            py: remCalc(16),
            gap: remCalc(16),
        },
        menuItem: {
            justifyContent: 'flex-start',
            textAlign: 'start',
            textDecoration: 'underline',
            fontWeight: 'normal',
            textStyle: 'body-small',
            color: 'text.default',
        },
    }),
}
